/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export interface OrderProduct {
  id: number;
  productId: number;
  syncUid: string;
  articul: string;
  header: string;
  unitHeader: string;
  manufacturerId: number;
  manufacturerHeader: string;
  manufacturerSeriesHeader: string;
  price: number;
  currencyCode: string;
  currencySign: string;
  amount: number;
  picture: string;
}
